import { useEffect } from 'react';
import { subscribe } from 'utility/general';

const useSubscribe = (channel, action = () => null) => {
    useEffect(() => {
        const unsubscribe = subscribe(channel, action);

        return () => {
            unsubscribe();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export default useSubscribe;
